import React from 'react';
import { translate } from 'react-i18next';

function NoDataFound({className, t}) {
  return (
    <div className={"animated fadeIn pt-1 text-center fz-12 " + (className || "text-white-50")}>
      {t('txt-no-data-found')}
    </div>
  );
}

export default translate('translations')(NoDataFound);
